import dayjs from 'dayjs';
import * as Sentry from '@sentry/vue';

import { initI18n } from '@samknows/design-system';
import { prefStorage } from '@samknows/utils';
import config from '@/common/config';
import VueI18Next from '@panter/vue-i18next';

function getLocaleFromURL(): string {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  const localeFromParam = config.locales.find(
    (locale) => langParam === locale.code.split('-')[0]
  );

  return localeFromParam?.code;
}

export function setupLocalisation(): VueI18Next {
  const localeFromParam = getLocaleFromURL();
  // Lang query parameter takes priority over saved user preferences
  // If no query parameter or saved locale is found, the locale is detected based on browser preferences by initI18n
  const locale = localeFromParam || prefStorage.get<string>('locale');

  return initI18n(config, locale, (locale) => {
    Sentry.setTag('locale', locale);
    dayjs.locale(locale.toLowerCase());
    // Set the lang attribute on the html element to the locale for accessibility
    document.documentElement.lang = locale;
  });
}
